import { render, staticRenderFns } from "./PasswordResetComplete.vue?vue&type=template&id=76a73389"
import script from "./PasswordResetComplete.vue?vue&type=script&lang=js"
export * from "./PasswordResetComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports